
<!--<div *ngIf="isMobile">
  <app-project-documents-mobile></app-project-documents-mobile>
</div>-->

<div *ngIf="!isMobile">
  <div *ngIf="documents" class="container-fluid">
    <div class="form-inline">
      <h5 class="mr-1" i18n>Documents</h5>
      <button class="btn btn-bidit-navigate" (click)="addDocument()" i18n>Add Document</button>
    </div>

    <table class="table table-bidit table-striped">
      <thead>
        <tr>
          <th i18n>File Name</th>
          <th i18n>Description</th>
          <th i18n>Date Uploaded</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        <tr *ngIf="this.documents.length == 0">
          <td colspan="4" i18n>No documents for this quote exist</td>
        </tr>
        <tr *ngFor="let document of documents">
          <td>
            {{document.quoteNote_Attachment}}
          </td>
          <td>
            {{document.quoteNote_Text}}
          </td>
          <td>
            {{document.quoteNote_Created | date: 'M/d/yyyy'}}
          </td>
          <td>
            <button (click)="downloadAttachment(document)" class="btn btn-bidit-navigate mr-1" i18n>Download</button>
            <a (click)="editDocument(document)" class="btn btn-bidit-edit mr-1"></a>
            <button (click)="deleteDocument(document)" class="btn btn-bidit-delete mr-1"></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
